var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.605 34.2245L25.0016 26.8278L32.396 34.2221C32.6503 34.4765 32.9829 34.6 33.3105 34.6C33.641 34.6 33.9712 34.4732 34.2226 34.2245L34.225 34.2221C34.7293 33.7178 34.7293 32.8989 34.225 32.3945L26.8306 25.0001L34.2221 17.6059C34.7265 17.1015 34.7265 16.2826 34.2221 15.7783C33.7178 15.2739 32.8989 15.2739 32.3945 15.7783L25.0002 23.1726L17.6059 15.7783C17.1015 15.2739 16.2826 15.2739 15.7783 15.7783C15.2739 16.2826 15.2739 17.1015 15.7783 17.6059L23.1726 25.0002L15.7783 32.3945C15.2739 32.8989 15.2739 33.7178 15.7783 34.2221C16.0326 34.4765 16.3652 34.6 16.6928 34.6C17.0233 34.6 17.3535 34.4732 17.605 34.2245Z",
    fill: "#3D3E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.7752d6273cc4a6c5e59438f14ee20a91.svg";
export { ForwardRef as ReactComponent };